import type { Product } from "@/interfaces/product";

/** What the preview hands the slide-in for a tapped card: builder read-only mode on the Details tab,
 *  and nothing at all (closed, no stale product/loading/error) when no card is open. */
export function previewDetailPanelState(
  openProductId: string | null,
  query: { data?: Product; isLoading: boolean; isError: boolean },
): {
  open: boolean;
  product: Product | null;
  loading: boolean;
  error: boolean;
  mode: "campaignBuilder";
  initialTab: "details";
} {
  const open = openProductId !== null;
  return {
    open,
    product: open ? (query.data ?? null) : null,
    loading: open && query.isLoading,
    error: open && query.isError,
    mode: "campaignBuilder",
    initialTab: "details",
  };
}
